import { render, staticRenderFns } from "./MyTeams.vue?vue&type=template&id=75753ab8&scoped=true"
import script from "./MyTeams.vue?vue&type=script&lang=js"
export * from "./MyTeams.vue?vue&type=script&lang=js"
import style0 from "./MyTeams.vue?vue&type=style&index=0&id=75753ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75753ab8",
  null
  
)

export default component.exports